/**
 * Detect a Sharetribe Console "login as user" session.
 *
 * Those sessions carry exactly one auth scope: `user:limited`. The app already
 * uses that signal for the LimitedAccessBanner and the operator cancel-reason
 * UI — keep the check in one place.
 *
 * @param {string[]|null|undefined} authScopes
 * @returns {boolean}
 */
export const isConsoleLoginAs = authScopes =>
  Array.isArray(authScopes) && authScopes.length === 1 && authScopes[0] === 'user:limited';
